// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kd4ocuG8GaFAB7GJdGpw {\n  padding: 24px;\n}\n", "",{"version":3,"sources":["webpack://./../../common/pages/accountDashboard/accountDashboardPage.module.less"],"names":[],"mappings":"AAGA;EACE,aAAA;AAFF","sourcesContent":["@import '../../../styles/common-variables';\n@import '../../../styles/antd-variables';\n\n.accountDashboardPage {\n  padding: @spacer-num-md;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"accountDashboardPage": "kd4ocuG8GaFAB7GJdGpw"
};
export default ___CSS_LOADER_EXPORT___;
